import { Helmet } from 'react-helmet';
import { Alert, Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import EmployeeListResults from 'src/components/pages/vaccination/employee/EmployeeListResults';
import EmployeeListToolbar from 'src/components/pages/vaccination/employee/EmployeeListToolbar';
import masterStatus from 'src/models/status';
import React, { Component } from "react";
import { _axios } from 'src/plugins/axios';
import { useParams } from "react-router-dom";
import * as _ from 'lodash'
import commonService from 'src/service/common'
import { Button } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';

const masterDataCountItems = JSON.parse(JSON.stringify(masterStatus))

class EmployeeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusSelected: '',
      totalCount: 0,
      dateRange: [],
      masterData: [],
      exportConfig: {
        columns: [],
        datas: []
      },
      selectionData: {
        campLocation: [],
        providerName: [],
        campType: []
      }, 
      filters: {},
      loading: false,
      showSnack: false,
      snackMsg: '',
      snackType: 'info',
      statusCount: [],
    }
  }
  startIndex = 0;
  pageSize = 25;
  statusIds = null;
  currentMasterData = [];
  getStatusCount(){
    if(sessionStorage.getItem('statuscount')) {
      this.setState({
        statusCount: JSON.parse(sessionStorage.getItem('statuscount')).masterDataCountItems
      })
      return
    }
    const payload = {
      statType: 'day'
    }
    this.setState({
      statusCount: JSON.parse(JSON.stringify(masterDataCountItems))
    },()=>{
      _axios.post('masterData/getAllTypeCount?contractType=14364', payload, {ignoreLoading: true})
      .then((response) => {
        if(response.data){
          const data = [...this.state.statusCount]
          _.keysIn(response.data).forEach((key) => {
            data.forEach((status, idx) => {
              status.totalCount += response.data[key][status.statusName] ? response.data[key][status.statusName] : 0
            })
          })
          data.forEach((data) => {
            data.totalCount = data.totalCount ? data.totalCount : 'NA'
          })
          sessionStorage.setItem('statuscount', JSON.stringify({
            masterDataCountItems: data
          }))
          this.setState({
            statusCount:data
          })
        }
      }).catch((error) => {
          // alert(error);
      })
    })
  }
  fetchRecords() {
    if (window.sessionStorage.getItem('statusId')) {
      this.statusId = JSON.parse(window.sessionStorage.getItem('statusId'))
      if (this.statusId && this.statusId.length) {
        let status = masterDataCountItems.find(status => status.statusId.toString() === this.statusId.toString())
        if (status) {
          this.setState({
            statusSelected: status.status
          })
          this.setState(prevState => ({
            filters: {
              ...prevState.filters,
              status: status.status
            }
        }))
        }
      }
    } else {
      this.statusId = null;
      this.setState({
        statusSelected: ''
      })
    }
    _axios.post('masterData/MasterData', {
      "startIndex": this.startIndex,
      "pageSize": this.pageSize,
      "statusIds": this.statusId && this.statusId.length > 0 ? this.statusId : null,
    }, {
      headers: {
        authtoken: commonService.getAuthToken()
      }
    }
    )
      .then((response) => {
        if (response.data.isSuccess && response.data.masterData) {
          this.setState({
            masterData: response.data.masterData,
            totalCount: response.data.count
          })
          this.currentMasterData = response.data.masterData;
          let exportOption = {
            columns: [],
            datas: []
          }
          this.currentMasterData.forEach(item => {
            exportOption.datas.push(item)
          })
          Object.keys(this.currentMasterData[0]).forEach((key) => {
            let header = key.replace(/([A-Z])/g, " $1")
            exportOption.columns.push({ id: key, displayName: header.charAt(0).toUpperCase() + header.slice(1) })
          })
          this.setState({
            exportConfig: exportOption
          })
        } else {
          this.setState({
            masterData: [],
            totalCount: 0,
            exportConfig: {
              columns: [],
              datas: []
            }
          })
          this.currentMasterData = [];
        }
      }).catch((error) => {
        // alert(error);
      })
  }

  fetchFiltersValues() {
    if(sessionStorage.getItem('filterOptions')) {
      this.setState({
        selectionData: {
          campLocation: JSON.parse(sessionStorage.getItem('filterOptions')).campLocationList,
          providerName: JSON.parse(sessionStorage.getItem('filterOptions')).providerNameList,
          campType: JSON.parse(sessionStorage.getItem('filterOptions')).campTypeList
        }
      })
      return
    }
    _axios.get('masterData/filter', {
      headers: {
        authtoken: commonService.getAuthToken()
      }
    })
    .then((res) => {
      // console.log(res)
      this.setState({
        selectionData: {
          campLocation: res.data.campLocation,
          providerName: res.data.providerName,
          campType: res.data.campType
        }
      })
    }).catch((err) => {
      // console.log(err)
    })
  }

  componentDidMount() {
    this.fetchRecords()
    this.fetchFiltersValues()
    this.getStatusCount()
  }

  componentWillUnmount() {
    window.sessionStorage.removeItem('statusId')
  }


  onFilterChange(type, value) {
    switch (type) {
      case 'limit':
        this.pageSize = value;
        break;
      case 'page':
        this.startIndex = value;
        break;
      case 'removeStatus':
        window.sessionStorage.removeItem('statusId')
        this.pageSize = 25;
        this.startIndex = 0;
    }
    if(Object.keys(this.state.filters).length === 0) {
      // this.pageSize = 25;
      // this.startIndex = 0;
      this.fetchRecords()
    } else {
      this.filterData(this.state.filters)
    }
  }

  exportFile(obj, filetype) {
    let payload = {
      fileType: filetype
    }
    Object.keys(obj).map((item) => {
      if (item !== 'dateRange' && item !== 'status') {
        payload[item] = obj[item]
      }
    })
    if (obj.hasOwnProperty('status')) {
      let statusids = masterDataCountItems.find(status => status.status.toString() === obj.status.toString()).statusId
      payload["statusIds"] = [...statusids]
    }
    if (obj.hasOwnProperty('dateRange')) {
      let startDate = new Date(obj.dateRange[0])
      let endDate = new Date(obj.dateRange[1])
      payload["apptDateBegin"] = startDate.getFullYear() + "-" + (("0" + (startDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + startDate.getDate()).slice(-2)
      payload["apptDateEnd"] = endDate.getFullYear() + "-" + (("0" + (endDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + endDate.getDate()).slice(-2)
    }
    this.setState({ 
      loading: true,
      showSnack: true,
      snackMsg: 'File will be downloaded in a moment',
      snackType: 'info'
    })
    _axios.post('masterData/fileExport', payload, {
      ignoreLoading: true,
      headers: { authtoken: commonService.getAuthToken() }
    }).then((response) => {
      if(response.data && response.data.preSignedUrl) {
        this.downloadFile(response.data.preSignedUrl)
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded successfully!',
          snackType: 'success',
        })
      } else if(response.data && !response.data.isSuccess) {
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error',
        })
      }
    }).catch((err) => {
      this.setState({ 
        loading: false,
        showSnack: true,
        snackMsg: 'File downloaded failed!',
        snackType: 'error'
      })
    })
  }

  downloadFile(url) {
    var link = document.createElement("a");
    link.setAttribute('download', '');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  filterData(obj) {
    
    let payLoad = {}
    
    payLoad["startIndex"] = this.startIndex
    payLoad["pageSize"] = this.pageSize
  
    Object.keys(obj).map((item) => {
      if (item !== 'dateRange' && item !== 'status') {
        payLoad[item] = obj[item]
      }
    })
    if (obj.hasOwnProperty('status')) {
      let statusids = masterDataCountItems.find(status => status.status.toString() === obj.status.toString()).statusId
      if(statusids.length > 0) payLoad["statusIds"] = [...statusids]
      else payLoad["statusIds"] = null
    }
    if (obj.hasOwnProperty('dateRange')) {
      // payLoad["apptDateBegin"] = obj.dateRange[0]
      // payLoad["apptDateEnd"] = obj.dateRange[1]
      let startDate = new Date(obj.dateRange[0])
      let endDate = new Date(obj.dateRange[1])
      payLoad["apptDateBegin"] = startDate.getFullYear() + "-" + (("0" + (startDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + startDate.getDate()).slice(-2)
      payLoad["apptDateEnd"] = endDate.getFullYear() + "-" + (("0" + (endDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + endDate.getDate()).slice(-2)
    }
    _axios.post('masterData/MasterData', payLoad, {
      headers: {
        authtoken: commonService.getAuthToken()
      }
    }
    )
      .then((response) => {
        if (response.data.isSuccess && response.data.masterData) {
          // console.log(response.data)
          this.setState({
            masterData: response.data.masterData,
            totalCount: response.data.count
          })
          let exportOption = {
            columns: [],
            datas: []
          }
          let currentData = response.data.masterData
          currentData.forEach(item => {
            exportOption.datas.push(item)
          })
          Object.keys(currentData[0]).forEach((key) => {
            let header = key.replace(/([A-Z])/g, " $1")
            exportOption.columns.push({ id: key, displayName: header.charAt(0).toUpperCase() + header.slice(1) })
          })
          this.setState({
            exportConfig: exportOption
          })
        } else if (response.data.errorMessage) {
          this.setState({
            exportConfig: {
              columns: [],
              datas: []
            } 
          })
          // console.log(response.data)
        } else {
          this.setState({
            exportConfig: {
              columns: [],
              datas: []
            } 
          })
        }
      }).catch((error) => {
        // console.log(error)
      })
  }

  searchEmployees(searchType, searchText) {
    _axios.post('search/emailOrPhone', {
      [searchType]: searchText,
    }, {
      headers: {
        authtoken: commonService.getAuthToken()
      }
    }
    )
      .then((response) => {
        if (response.data && response.data.length) {
          this.setState({
            masterData: response.data,
            totalCount: response.data.length
          })
        } else {
          this.setState({
            masterData: this.currentMasterData,
            showSnack: true,
            snackMsg: 'No results found',
            snackType: 'info'
          })
        }
      }).catch((error) => {
        // alert(error);
      })
    //   setTimeout(() => {
    //     let filteredEmployees = this.currentMasterData.filter(employee => (employee.patientName.toLowerCase().indexOf(searchText.toLowerCase()) > -1 || employee.emailId.toLowerCase().indexOf(searchText.toLowerCase()) > -1 || employee.phoneNumber.indexOf(searchText) > -1))
    //     this.setState({
    //       masterData: filteredEmployees
    //     })
    //   }, 2000);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Vaccination | Bookings</title>
        </Helmet>
        {/* <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
          }}
        > */}
          <Container maxWidth={false}>
            <Card sx={{
              my: 2,
              borderRadius: 4,
              boxShadow: '0 0 4px rgba(0,0,0,0.15)'
            }}>
              <EmployeeListToolbar exportData={(obj, filetype) => this.exportFile(obj, filetype)} loading={this.state.loading} refreshData={(obj) => {this.setState({ filters: obj }); this.filterData(obj)}} selectionData={this.state.selectionData} exportConfig={this.state.exportConfig} searchEmployees={_.debounce((this.searchEmployees.bind(this)), 800)} removeStatusFilter={(type) => this.onFilterChange(type)} statusSelected={this.state.statusSelected} statusCount={this.state.statusCount}/>
              <Box>
              {(this.state.masterData.length && this.state.totalCount) ?
                <EmployeeListResults employees={this.state.masterData} onPaginationChange={(type, value) => this.onFilterChange(type, value)} totalCount={this.state.totalCount} isDashboard={false} />
                : 
                <Card 
                elevation={0}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 50
                }}>
                  <Typography color="textSecondary" variant="h5"> No records found </Typography>
                </Card>
                }
              </Box>
            </Card>
          </Container>
        {/* </Box> */}
        <Snackbar open={this.state.showSnack} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} autoHideDuration={4000} onClose={()=> this.setState({ showSnack: false})}>
          <Alert onClose={()=> this.setState({ showSnack: false})} severity={this.state.snackType}>
            {this.state.snackMsg}
          </Alert>
        </Snackbar>
      </>
    )
  }
}
export default (props) => {
  return (<EmployeeList {...props} />)
}
